import React from 'react';

import { Link as RouterLink } from '@tanstack/react-router';


const Link = React.forwardRef((props, ref) => {
  const { to, href, children, ...restProps } = props;

  if (to) {
    return (
      <RouterLink ref={ref} to={to} {...restProps}>{children}</RouterLink>
    );
  }

  if (href) {
    return (
      <a ref={ref} href={href} {...restProps}>{children}</a>
    );
  }

  throw new Error('Provide \'to\' or \'href\'.');
});

Link.displayName = 'Link';
export default Link;
